<template>
    <div>
        <modal-component v-if="showModal" @close="close()" :container-style="'width:90%'">
            <h3 slot="header"><strong>Subject:</strong> {{ subject }}</h3>

            <div slot="body">
                <div v-if="attachmentLinks" class="card-header mb-2" style="border: 1px solid rgba(0, 0, 0, 0.125);">
                    <strong>Attachments: </strong>
                    <ul class="mb-0">
                        <li v-for="(link, index) in attachmentLinks" v-bind:key="index">
                        <a :href="link.url+ '?preview=true'" target="_blank">{{ link.name }} <i class="mdi mdi-open-in-new"></i></a>
                        </li>
                    </ul>
                    <span><small>* These are preview links for coaches. Do not share with clients</small></span>
                </div>

                <div class="card">
                    <div class="card-header">
                        <ul class="nav nav-tabs card-header-tabs pull-right" id="myTab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="html-preview-tab" data-toggle="tab" href="#html-preview-panel" role="tab" aria-controls="html-preview-panel" aria-selected="false">HTML</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="text-preview-tab" data-toggle="tab" href="#text-preview-panel" role="tab" aria-controls="text-preview-panel" aria-selected="false">TEXT</a>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body">
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane show active" id="html-preview-panel" role="tabpanel" aria-labelledby="html-preview-tab">
                                <div v-html="html"></div>
                            </div>
                            <div class="tab-pane" id="text-preview-panel" role="tabpanel" aria-labelledby="text-preview-tab">
                                <pre class="pre-wrap" v-text="text"></pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <button class="btn btn-default" @click="close()">Cancel</button>
                <!-- <button v-if="hasPrimaryAction" @click="doPrimaryAction()" class="btn btn-primary">{{ primaryActionLabel }}</button> -->
            </div>
        </modal-component>
    </div>
</template>
<script>
export default {
  props: [
    'show',
    'subject',
    'text',
    'html',
    'attachmentLinks',
    // 'primaryActionLabel',
  ],
  data() {
    return {
      showModal: this.show,
    }
  },
  mounted() {
  },
  computed: {
    // hasPrimaryAction: function(){
    //   return this.primaryActionLabel?.length > 0;
    // }
  },
  methods: {
    close: function() {
      this.showModal = false;
      this.$emit('close');
    },
    // doPrimaryAction: function() {
    //   this.showModal = false;
    //   this.$emit('primaryAction');
    // },
  },
  watch: {
    show: function (newVal,oldVal) {
      Vue.set(this, 'showModal', newVal);
    }
  }
}
</script>
